import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MitgliedDto} from '@wba/models/dto/mitglied-dto';
import {MitgliederDomainDto} from '@wba/models/dto/mitglieder-domain-dto';
import {MitgliedService} from '@wba/services/api/mitglied/mitglied.service';
import {RequestBodyEinkommen} from '@wba/services/api/mitglied/request-body-einkommen.interface';
import {ResponseBody} from '@wba/services/api/mitglied/response-body.interface';
import {AbstractApiService} from '@wba/services/commons/abstract-api.service';
import {DateUtils} from '@wba/utils/date.utils';
import {Observable, throwError} from 'rxjs';
import {catchError, map, share} from 'rxjs/operators';

@Injectable()
export class MitgliedImplService extends AbstractApiService implements MitgliedService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  getMitglieder(antragId: string): Observable<MitgliederDomainDto> {
    return this.get<MitgliederDomainDto>(`/mitglied/mitglieder`, {antragId})
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error.message);
        }),
        share()
      );
  }

  getMitgliederFuerAnlageEk(antragId: string): Observable<{ id: string, name: string }[]> {

    return this.post(`/anlage_ek/mitglieder`, {antragId}).pipe(
      map((response: { success }) => response.success as MitgliederDomainDto),
      map((mitglieder: MitgliederDomainDto) => mitglieder.mitglieder),
      map((mitglieder: MitgliedDto[]) => {
          return mitglieder.map(m => {
            return {
              id: m.id,
              name: `${m.vorname} ${m.nachname} (${DateUtils.format(m.geburtsdatum, 'YYYY-MM-DD', 'DD.MM.YYYY')})`
            };
          });
        }
      ));
  }

  getEinkommenByMitglied(antragId: string): Observable<RequestBodyEinkommen> {
    return this.get<RequestBodyEinkommen>(`/mitglied/einkommen`, {antragId})
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error.message);
        })
      );
  }

  updateMitglieder(mitglied: any, antragId: string, withCleanup = true) {
    return this.put<ResponseBody>(`/mitglied/mitglieder`, {
      mitglieder: mitglied.mitglieder,
      bg: mitglied.bg
    }, {antragId, withCleanup});
  }

  updateEinkommen(einkommen, antragId) {
    return this.put<ResponseBody>(`/mitglied/einkommen`, einkommen, {antragId});
  }

  updateNachweise(antragId, mitglieder: { mitgliedId: string, nachweisId: string }[]) {
    return this.post(`/mitglied/nachweise`, mitglieder, {antragId});
  }

  deleteMitglied(mitgliedId, antragId) {
    return this.delete(`/mitglied`, {antragId, mitgliedId});
  }

  deleteEinkommen(ids: number[], antragId) {
    return this.deleteWithBody('/mitglied/einkommen', ids, {antragId});

  }
}
